import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiHome,
  FiSearch,
  FiRepeat,
  FiPackage,
  FiShuffle,
  FiTag,
  FiSettings,
} from 'react-icons/fi';

const navItems = [
  { to: '/', label: 'Home', icon: FiHome },
  { to: '/labels', label: 'Labels', icon: FiTag },
  { to: '/lookup', label: 'Lookup', icon: FiSearch },
  { to: '/cycle-count', label: 'Cycle', icon: FiRepeat },
  { to: '/receiving', label: 'Receive', icon: FiPackage },
  { to: '/transfers', label: 'Transfer', icon: FiShuffle },
  { to: '/settings', label: 'Settings', icon: FiSettings },
];

const HandheldNav = () => {
  return (
    <nav aria-label="Handheld navigation" className="bg-slate-900 text-white border-t border-slate-800 overflow-x-auto">
      <div className="flex min-w-[28rem] justify-between">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `flex-1 min-h-11 flex flex-col items-center py-3 text-xs font-semibold ${
                  isActive ? 'text-amber-400' : 'text-slate-300'
                }`
              }
              end={item.to === '/'}
            >
              <Icon className="text-xl mb-1" />
              {item.label}
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default HandheldNav;
